import React from "react";
import CashOutRuleForm from "../../Components/CashOutRule/CashOutRuleForm";

const CashOutRulePage = () => {
  return <CashOutRuleForm />;
};

export default CashOutRulePage;
